import React from 'react';
import PropTypes from 'prop-types';

import GroupWrapper from '../GroupWrapper';
import File, { propTypes as filesPropTypes } from '../File';

const FilesGroup = ({
  title, files,
}) => (
  <GroupWrapper title={title}>
    {files.map((item) => <File {...item} />)}
  </GroupWrapper>
);

FilesGroup.propTypes = {
  title: PropTypes.string,
  files: PropTypes.arrayOf(filesPropTypes).isRequired,
};

FilesGroup.defaultProps = {
  title: null,
};

export default FilesGroup;
